var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"line-notify"},[_c('el-header',{staticClass:"page-header",attrs:{"height":"max-content"}},[_c('h4',{staticClass:"header-title"},[_c('b',[_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")])])]),_vm._v(" "),_c('el-main',{staticClass:"page-main"},[_c('router-view',{attrs:{"width":_vm.width}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }